import React from "react";
import { useQueryClient } from "react-query";
import { message, Empty } from "antd";
// Job Table element
import JobTableElement from "../../components/SFTPConnector/JobTableElement";
import Breadcrumb from "../../components/Breadcrumb";
import LoadingComponent from "../../components/Common/LoadingComponent";
// sftp job react query calls
import { useGetJobs, useDeleteJob } from "../../hooks/sftp.hooks";

const JobConfigView = (props) => {
  const queryClient = useQueryClient();

  let tableHeight = 300;
  if (window.innerWidth > 700) {
    tableHeight = window.innerHeight - 300;
  }

  // Get sftp job react query call
  const { isLoading: isLoadingSFTPData, data: SFTPJobData } = useGetJobs();

  // Delete sftp job react query call
  const deleteOptions = {
    onSuccess: () => {
      message.success("Job Deleted Successfully");
    },
    onError: (error) => {
      message.error("Internal Server Error");
      console.error(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries("SFTPJobData");
    },
  };

  const { mutate: mutateDeleteJob, isLoading: isLoadingDeleteJob } =
    useDeleteJob(deleteOptions);

  const handleDelete = (key) => {
    mutateDeleteJob(key);
  };

  return (
    <div>
      <div className="container_aa">
        <h3>SFTP Job View</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            {
              path: "JobConfigView",
              breadcrumbName: "SFTP Job View ",
            },
          ]}
        />
      </div>
      <div className="container_ab">
        <div className="container_style_1_b" style={{ width: "100%" }}>
          <JobTableElement
            bordered
            className="sm-custom-column-header"
            scroll={{ x: 4750, y: tableHeight }}
            dataSource={SFTPJobData}
            handleDelete={handleDelete}
            isLoadingDeleteJob={isLoadingDeleteJob}
            rowKey="_id"
            locale={{
              emptyText: isLoadingSFTPData ? (
                <div className="spinner-table">
                  <LoadingComponent />
                </div>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default JobConfigView;
